class APIS {
	apis() {
		return {
			fetchAboutUs: {
				headers: {
					"xt-user-token": null,
				},
				method: "get",
				path: "/fetch/about/true",
			},
			
		};
	}
}

export default new APIS();
